import React from "react";
import classes from "../homepage/About.module.css";
import img1 from "../../assets/mech-nfts/mars_mech.png";
import img2 from "../../assets/mech-nfts/mech1.png";
import img3 from "../../assets/mech-nfts/mech2.png";
import img4 from "../../assets/mech-nfts/mech3.png";
import img5 from "../../assets/mech-nfts/mech4.png";
import img6 from "../../assets/mech-nfts/mech5.png";
import img7 from "../../assets/mech-nfts/mech6.png";
import img8 from "../../assets/mech-nfts/mech7.png";
import img9 from "../../assets/mech-nfts/Untitled_Artwork 13.png";
import img10 from "../../assets/mech-nfts/Untitled_Artwork 14.png";
import img11 from "../../assets/mech-nfts/Untitled_Artwork 16.png";
import img12 from "../../assets/mech-nfts/Untitled_Artwork 18.png";
import img13 from "../../assets/mech-nfts/Untitled_Artwork 20.png";
import img14 from "../../assets/mech-nfts/Untitled_Artwork 21.png";
import img15 from "../../assets/mech-nfts/Untitled_Artwork 9.png";
import img16 from "../../assets/mech-nfts/Untitled_Artwork 9.png";
import img17 from "../../assets/mech-nfts/Untitled_Artwork 21.png";
import img18 from "../../assets/mech-nfts/Untitled_Artwork 20.png";
import img19 from "../../assets/mech-nfts/mars_mech.png";
import img20 from "../../assets/mech-nfts/mech1.png";
import img21 from "../../assets/mech-nfts/mech2.png";
import img22 from "../../assets/mech-nfts/mech3.png";
import img23 from "../../assets/mech-nfts/mech4.png";
import img24 from "../../assets/mech-nfts/mech5.png";
import img25 from "../../assets/mech-nfts/mech6.png";
import img26 from "../../assets/mech-nfts/mech7.png";
import img27 from "../../assets/mech-nfts/Untitled_Artwork 13.png";
import img28 from "../../assets/mech-nfts/Untitled_Artwork 14.png";
import img29 from "../../assets/mech-nfts/Untitled_Artwork 16.png";
import img30 from "../../assets/mech-nfts/Untitled_Artwork 18.png";
import img31 from "../../assets/mech-nfts/Untitled_Artwork 20.png";
import img32 from "../../assets/mech-nfts/Untitled_Artwork 21.png";
import img33 from "../../assets/mech-nfts/Untitled_Artwork 9.png";
import img34 from "../../assets/mech-nfts/Untitled_Artwork 9.png";
import img35 from "../../assets/mech-nfts/Untitled_Artwork 21.png";
import img36 from "../../assets/mech-nfts/Untitled_Artwork 20.png";
import img37 from "../../assets/Planet_Red.png";

const About: React.FC = () => {
  return (
    <div className={classes["about-wrapper"]}>
      <div className={classes["about-content-wrapper"]}>
        <h3 className={classes["about-title"]} data-aos="fade-left">
          Space Kitties? Battle Mechs?
        </h3>
        <div className={classes["about-text"]} data-aos="fade-right">
          Star crossed with the power of Naisu and Kawaii, Space Kitties are
          fiercely adorable deep-space mech pilots on the Solana Blockchain.
          Battle Mechs are the gen2 collection release of the Space Kitties
          project - 1,250 mechs assembled and piloted by the Kitties into
          battle. Pair up your own Space Kitty with their Battle Mech to
          compete in tournaments, crush your enemies, collect $PACE and win
          prizes!
        </div>
      </div>
      <div
        className={`${classes["about-content-wrapper"]} ${classes["about-img-wrapper-mobile"]}`}
      >
        <div className={classes["about-img-row-mobile"]}>
          <img className={classes["about-img"]} src={img1} alt="" />
          <img className={classes["about-img"]} src={img2} alt="" />
          <img className={classes["about-img"]} src={img3} alt="" />
          <img className={classes["about-img"]} src={img4} alt="" />
          <img className={classes["about-img"]} src={img5} alt="" />
          <img className={classes["about-img"]} src={img6} alt="" />
          <img className={classes["about-img"]} src={img7} alt="" />
          <img className={classes["about-img"]} src={img8} alt="" />
          <img className={classes["about-img"]} src={img9} alt="" />
        </div>

        <div
          className={`${classes["about-img-row-mobile"]} ${classes["about-img-row-alternate"]}`}
        >
          <img className={classes["about-img"]} src={img10} alt="" />
          <img className={classes["about-img"]} src={img11} alt="" />
          <img className={classes["about-img"]} src={img12} alt="" />
          <img className={classes["about-img"]} src={img13} alt="" />
          <img className={classes["about-img"]} src={img14} alt="" />
          <img className={classes["about-img"]} src={img15} alt="" />
          <img className={classes["about-img"]} src={img16} alt="" />
          <img className={classes["about-img"]} src={img17} alt="" />
          <img className={classes["about-img"]} src={img18} alt="" />
        </div>
      </div>
      <div
        className={`${classes["about-content-wrapper"]} ${classes["about-img-wrapper-desktop"]}`}
      >
        <div className={classes["about-img-row"]}>
          <img className={classes["about-img"]} src={img19} alt="" />
          <img className={classes["about-img"]} src={img20} alt="" />
          <img className={classes["about-img"]} src={img21} alt="" />
          <img className={classes["about-img"]} src={img22} alt="" />
          <img className={classes["about-img"]} src={img23} alt="" />
          <img className={classes["about-img"]} src={img24} alt="" />
          <img className={classes["about-img"]} src={img25} alt="" />
          <img className={classes["about-img"]} src={img26} alt="" />
          <img className={classes["about-img"]} src={img27} alt="" />
          <img className={classes["about-img"]} src={img28} alt="" />
          <img className={classes["about-img"]} src={img29} alt="" />
          <img className={classes["about-img"]} src={img30} alt="" />
          <img className={classes["about-img"]} src={img31} alt="" />
          <img className={classes["about-img"]} src={img32} alt="" />
          <img className={classes["about-img"]} src={img33} alt="" />
          <img className={classes["about-img"]} src={img34} alt="" />
          <img className={classes["about-img"]} src={img35} alt="" />
          <img className={classes["about-img"]} src={img36} alt="" />
        </div>
      </div>
      <img className={classes["planet-red"]} src={img37} alt="" />
    </div>
  );
};

export default About;
